export enum AuthFormType {
  SIGN_UP = "SIGN_UP",
  SIGN_IN = "SIGN_IN",
}
